// Import Olympe runtime or DRAW
import 'olympe';

// Import project bricks (we use webpack-import-glob-loader to import all bricks)
import './common/ComputeDestinationPoint.js';
import './web/MapboxCamera.js'; import './web/MapboxMap.js'; import './web/MapboxMarker.js';

